
import { useStore as useOrderStore } from "@/stores/order";
import { useStore as useMainStore } from "@/stores/main";
import Orderline from "@/types/Orderline";
import {
  defineComponent,
  PropType,
  computed,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiAlertCircle, mdiLoading, mdiPencil, mdiBarcodeScan } from "@mdi/js";
import OrderLine from "./OrderLine.vue";
import onScan from "onscan.js";
import { Howl, Howler } from "howler";
import Modal from "../General/Modal.vue";
import TextButton from "../Buttons/TextButton.vue";

export default defineComponent({
  setup() {
    const orderStore = useOrderStore();
    const isWeborder = computed(() => orderStore.isWeborder);

    let beep = new Howl({
      src: ["/audio/beep.wav"],
    });

    let errorBeep = new Howl({
      src: ["/audio/beep.wav"],
    });

    onMounted(() => {
      onScan.attachTo(document, {
        onScan: async (sCode: string, iQty: number) => {
          if (orderStore.paymentProcessing) {
            return;
          }

          if (beep.state() !== "loaded") {
            beep.load();
          }

          makeBeep();

          try {
            if (isWeborder.value) {
              await orderStore.scanProduct(sCode, iQty, "scan");
            } else {
              await orderStore.addProductFromBarcode(sCode, iQty);
            }
          } catch (error) {
            makeBeepError();
          }

          // Scroll orderlines to bottom
          // @ts-ignore
          document.getElementById("addProductAmount")?.blur();
          const detailsElement = document.getElementById("orderDetails");
          detailsElement?.scrollTo(0, detailsElement?.scrollHeight);
        },
        minLength: 4,
      });

      (window as any).onScan = onScan;
    });

    const makeBeep = () => {
      beep.seek(0);

      beep.play();
      setTimeout(() => {
        beep.fade(1, 0, 30).on("fade", () => {
          beep.stop();
          beep.volume(1);
        });
      }, 120);
    };

    const makeBeepError = () => {
      errorBeep.seek(0);
      errorBeep.volume(1);
      errorBeep.play();

      setTimeout(() => {
        errorBeep.fade(1, 0, 30).on("fade", () => {
          errorBeep.stop();
        });
      }, 1000);
    };

    // const simulateBarcode = () => {
    //   onScan.simulate(document, "7090018431142s");
    // };

    onUnmounted(() => {
      onScan.detachFrom(document);
    });

    // setTimeout(() => {
    //   onScan.simulate(document, "4764");
    // }, 1000);

    // setTimeout(() => {
    //   onScan.simulate(document, "8886467530449");
    // }, 1500);

    // setTimeout(() => {
    //   onScan.simulate(document, "7090018431142");
    // }, 2000);

    const orderlines = ref(orderStore.orderlines);
    const loadingLines = ref(orderStore.loadingOrderlines);

    orderStore.$subscribe((mutation, state) => {
      orderlines.value = state.orderlines;
      loadingLines.value = state.loadingOrderlines;
    });

    const mainStore = useMainStore();

    const barcodeSimOpen = ref(false);
    const barcodeSim = ref("");

    const simScan = () => {
      onScan.simulate(document, barcodeSim.value);
    };

    return {
      orderlines,
      loadingLines,
      // simulateBarcode,
      editIcon: mdiPencil,
      errorIcon: mdiAlertCircle,
      loadingIcon: mdiLoading,
      barcodeScanIcon: mdiBarcodeScan,
      env: computed(() => mainStore.env),
      barcodeSimOpen,
      barcodeSim,
      simScan,
      isWeborder,
    };
  },
  components: { Button, SvgIcon, OrderLine, Modal, TextButton },
});
